'use client';

import { useEffect, useRef } from 'react';
import posthog from 'posthog-js';

/**
 * Starts PostHog session replay recording when `enabled` becomes true.
 * Recording is disabled by default (see instrumentation-client.ts) and
 * only activated for high-value flows: registration (past step 1) and event admin.
 */
export function useSessionReplay(enabled: boolean) {
  const startedRef = useRef(false);

  useEffect(() => {
    if (enabled && !startedRef.current) {
      startedRef.current = true;
      posthog.startSessionRecording();
    }
  }, [enabled]);
}
